import React, { useMemo } from 'react'
import { CustomSwitch } from './CustomSwitch'
import Box from '@mui/material/Box'
import { Operation, RoleFormModel } from '@user/store/roles/typings'
import { InfoTooltip } from '@sales-center/components'
import { useFormikContext } from 'formik'

type Props = {
  operation: Operation
  disabled: boolean
  nestedOperations: Operation[]
  onChange: (
    value: boolean,
    permissionType: string,
    operation: string,
    id: number,
  ) => void
  permissionType: string
}

export function OperationListItem({
  disabled,
  nestedOperations,
  operation: { id, name, description },
  permissionType,
  onChange,
}: Props) {
  const { values } = useFormikContext<RoleFormModel>()
  const childOperations = useMemo(
    () => nestedOperations.filter((x) => x.parentId == id),
    [nestedOperations, id],
  )

  const isTopLevelSelected = useMemo(
    () => values.permissionOperations?.includes(id),
    [values, id],
  )

  return (
    <Box ml={1.5} key={id}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <CustomSwitch
          label={name}
          disabled={disabled}
          checked={isTopLevelSelected}
          onChange={() =>
            onChange(!isTopLevelSelected, permissionType, name, id)
          }
        />
        {description && (
          <InfoTooltip
            infoText={description}
            tooltipPlacement="right"
            sx={{ fontSize: '18px', ml: -1 }}
            iconColor="action"
          />
        )}
      </Box>
      {childOperations.map((childOperation) => {
        const isNestedSelected = values.permissionOperations?.includes(
          childOperation?.id,
        )
        return (
          <Box ml={3} key={childOperation?.id}>
            <CustomSwitch
              label={childOperation?.name}
              disabled={disabled}
              checked={isNestedSelected}
              onChange={() =>
                onChange(
                  !isNestedSelected,
                  permissionType,
                  childOperation?.name,
                  childOperation?.id,
                )
              }
            />
            <InfoTooltip
              infoText={childOperation?.description}
              tooltipPlacement="right"
              sx={{ fontSize: '18px', ml: -1 }}
              iconColor="action"
            />
          </Box>
        )
      })}
    </Box>
  )
}
